export default "__VITE_ASSET__a1f9b409__"